import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Exam|Metadata|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ClientMetadata,
	portal: 'SP',
};

export type SPExamMetadataLocNames =
	| 'SPExamMetadataTitleSection'
	| 'SPExamMetadataButtonEdit'
	| 'SPExamMetadataButtonCancel'
	| 'SPExamMetadataButtonSave'
	| 'SPExamMetadataButtonSaveSuccess'
	| 'SPExamMetadataNoChanges'
	| 'SPExamMetadataNone';

export const spExamMetadataLocs: LocDefs<SPExamMetadataLocNames> = {
	SPExamMetadataTitleSection: {
		defaultValue: 'Metadata',
		description: 'Section title for exam metadata',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPExamMetadataButtonEdit: {
		defaultValue: 'Edit',
		description: 'Edit button / tooltip',
		displayPath: `${pathStart}Edit`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPExamMetadataButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button / tooltip',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPExamMetadataButtonSave: {
		defaultValue: 'Save',
		description: 'Save button / tooltip',
		displayPath: `${pathStart}Save`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPExamMetadataButtonSaveSuccess: {
		defaultValue: 'Changes Saved',
		description: 'Save success message',
		displayPath: `${pathStart}Save success`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPExamMetadataNoChanges: {
		defaultValue: 'You must make at least one change',
		description: 'Shown when saving without any changes',
		displayPath: `${pathStart}No changes`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPExamMetadataNone: {
		defaultValue: 'No metadata found.',
		description: 'Shown when the catalog has no metadata',
		displayPath: `${pathStart}None`,
		displayType: 'Content',
		...sharedProperties,
	},
};

export type SPExamMetadataLocType = LocMap<SPExamMetadataLocNames>;
